module.exports = __webpack_public_path__ + "files/cb3625efa7f7697e0609b1ee54353306.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-Slab-regular.eot
 ** module id = 397
 ** module chunks = 0
 **/